/*
 * File: Sidebar.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on February 7, 2022 at 1:51 PM
 * Copyright © 2022 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 19, 2025 at 4:27 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';

// Components
import { IconButton } from '../../IconButton';

// Constants
import { AppNavSidebarWidth, AppNavTopbarHeight } from '../../../styles/constants';


/**
 * Styles
 */

export const Sidebar = styled.div`
	width: 98%;
	max-width: ${AppNavSidebarWidth}px;
	height: 100%;
	background-color: ${({ theme }) => theme.primaryBackground};
	border-right: 1px solid ${({ theme }) => theme.layoutBorder};
	padding: 15px 20px 60px 20px;
	overflow: auto;
	position: relative;
	z-index: 2;

	& > div {
		flex-direction: column;

		& > div {
			width: 100%;
		}
	}
`;

export const MobileNavigation = styled.div`
	margin-top: -15px;
	height: ${AppNavTopbarHeight}px;
	display: flex;
	align-items: center;
	position: relative;
	margin-left: -5px;
`;

export const NavigationToggle = styled(IconButton)`
	pointer-events: all;
`;
